import React, { Component } from 'react'
import Axios from 'axios';
import { Topography } from 'components/ui';
import errorbg from 'assets/images/404-bg.png';

const axios = Axios.create()

class ErrorBoundary extends Component {
    state = {
        hasError: false
    }
    static getDerivedStateFromError(error: any) {
        return { hasError: true };
    }

    componentDidCatch(error: any, info: any) {
        this.setState({ hasError: true })
        if (process.env.NODE_ENV == 'production') {
            axios.post('https://logs.collector.solarwinds.com/v1/log', { error, info }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic OkRkb21KLVpBUnNhNmdoS1ozVnFUVktvQ2NmcGI='
                }
            })
                .then(res => null)
                .catch(res => null)
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                // <div className='container'>
                //     <div className='row'>
                //         <div className='col-auto m-auto'>
                //             <Topography.H2 className='mt-5 text-danger'>Something went wrong.</Topography.H2>
                //             <div className='text-center'>Please refresh the page</div>
                //         </div>
                //     </div>
                // </div>
                <div className='error_main_wrapper'>
                    <img src={errorbg} />
                    <div className='col-auto m-auto errorText'>
                        <Topography.H2 className='mt-5'>Something went wrong</Topography.H2>
                        <ul className='error_link_list'>
                            <li><a href="">Take me to my last page!</a></li>
                            <li><a href={`${process.env.REACT_APP_BASE_API_URL}/login`}>Login</a></li>
                            <li><a href="/dashboard">Home Page</a></li>
                            <li><a href="http://www.chartrequest.com/contact" target='_blank'>Contact Us</a></li>
                        </ul>
                    </div>
                </div>
            )
        } else return this.props.children
    }
}

export default ErrorBoundary